import pictureMobile from './home-banner_mobile.jpg';
import pictureTablet from './home-banner_tablet.jpg';
import pictureDesktop from './home-banner_desktop.jpg';
import picture404Mobile from './404-banner_mobile.jpg';
import picture404Tablet from './404-banner_tablet.jpg';
import picture404Desktop from './404-banner_desktop.jpg';
import picture403Mobile from './403-banner_mobile.jpg';
import picture403Tablet from './403-banner_tablet.jpg';
import picture403Desktop from './403-banner_desktop.jpg';
import style from './home-banner.scss';

const script = () => {
  const cssClass: string = 'HomeBanner';
  const target: string = `.${cssClass}`;
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${cssClass}`]) {
      return true; // already init go to next iteration
    }
    // init element
    elt.dataset[`init${cssClass}`] = true;

    // Do your stuff here
    const content = elt.querySelector(`.${cssClass}-content`);
    const title = elt.querySelector(`.${cssClass}-title`);
    const subtitle = elt.querySelector(`.${cssClass}-subtitle`);

    const exceptionList: any = /[ÂÊÎÔÛÄËÏÖÜÇÉÈÀÇÉÈŒÙQ]/;
    const titleHTML = title.innerHTML;
    const subtitleHTML = subtitle.innerHTML;

    // Get width of elements on onload
    let contentWidth = content.offsetWidth;
    let homeBannerWidth = elt.offsetWidth;
    let contentFontSize: any = window.getComputedStyle(title, null).fontSize;

      window.addEventListener('load', () => {
        contentWidth = content.offsetWidth;

        // if text exceed HomeBanner width adapt font size
        if (contentWidth > homeBannerWidth) {
          adaptFontSize();
        }

        // Check if string contain special character and adjust line height
        if (titleHTML.search(exceptionList) > -1 || subtitleHTML.search(exceptionList) > -1) {
          adaptLineHeight();
        }
      });

      // on resize
      window.addEventListener('resize', () => {
        // update values
        if (title.style.removeProperty) {
          title.style.removeProperty('font-size');
          subtitle.style.removeProperty('font-size');
        } else {
          title.style.removeAttribute('font-size');
          subtitle.style.removeAttribute('font-size');
        }
        homeBannerWidth = elt.offsetWidth;
        contentWidth = content.offsetWidth;
        contentFontSize = window.getComputedStyle(title, null).fontSize;

        // if text exceed HomeBanner width adapt font size
        if (contentWidth > homeBannerWidth) {
          adaptFontSize();
        }

        // Check if string contain special character and adjust line height
        if (titleHTML.search(exceptionList) > -1 || subtitleHTML.search(exceptionList) > -1) {
          adaptLineHeight();
        }
      });

      function adaptFontSize() {
        const ratio = homeBannerWidth / contentWidth;
        let newFontSize: any = parseInt(contentFontSize, 10);
        newFontSize = newFontSize * ratio + "px";
        title.style.setProperty('font-size', newFontSize);
        subtitle.style.setProperty('font-size', newFontSize);
      }

      function adaptLineHeight() {
        title.style.setProperty('line-height', contentFontSize, 'important');
        subtitle.style.setProperty('line-height', contentFontSize, 'important');
      }
  }
};

export {
  pictureMobile,
  pictureTablet,
  pictureDesktop,
  picture404Mobile,
  picture404Tablet,
  picture404Desktop,
  picture403Mobile,
  picture403Tablet,
  picture403Desktop,
  style,
  script,
};
